<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="FM-Epigraph-non-verse-fmepi"><span class="ePub-I">“Give it up! Give it up!” he said, and turned away with a great swing of his body, like a man who wants to be alone with his laughter.</span></p>
<p class="FM-Epigraph-Source-fmeps">—Franz Kafka</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?14a98b28